"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GetUserMediaError_1 = __importDefault(require("./GetUserMediaError"));
class NotFoundError extends GetUserMediaError_1.default {
    constructor(cause) {
        super(cause);
        this.name = 'NotFoundError';
    }
}
exports.default = NotFoundError;
//# sourceMappingURL=NotFoundError.js.map